import React, { useState } from "react";
import Chevron from "../../../../assets/customSVG/ChevronCrm";
import WhatsappIconCrm from "../../../../assets/customSVG/whatsappIconCrm";
import { useAspSelector } from "test/jest-redux-hooks";

export const ConversationFilters = ({ activeFilter, setActiveFilter }) => {
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(true);
  const { currentBrand, currentUser } = useAspSelector((state) => state.app);

  return (
    <div className="mb-2">
      <div
        className="flex justify-between items-center px-4 py-3 cursor-pointer"
        onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
      >
        
        <p className="font14px-600 text-gray-800 mt-1 ">Conversations</p>

        <span
          className={`transition-transform duration-300 ${
            isFilterDropdownOpen ? "transform rotate-180" : ""
          }`}
        >
          <Chevron />
        </span>
      </div>

      <div
        className={`transition-all duration-200 overflow-hidden ${
          isFilterDropdownOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div 
          className={`flex items-center gap-3 mx-4 px-3 py-2 rounded-md cursor-pointer ${
            activeFilter === 0 ? "sidebar-sub-header-active" : "sidebar-sub-header hover:bg-slate-100"
          }`}
          onClick={() => 
            {
              setActiveFilter(0);
            }
          }
        >
          <div className="text-green-600">
          <WhatsappIconCrm />

          </div>
          <p className={`${activeFilter === 0 ? "text-green-700 font14px-500" : "font14px-400 text-gray-700"}`}>
            All Contacts
          </p>
        </div>

        <div 
          className={`flex items-center gap-3 mx-4 px-3 py-2 rounded-md cursor-pointer ${
            activeFilter.full_name === currentUser.full_name ? "sidebar-sub-header-active" : "sidebar-sub-header hover:bg-slate-100"
          }`}
          onClick={() => {
            setActiveFilter(currentUser);
          }
        }
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            strokeWidth="1.5" 
            stroke="currentColor" 
            className="w-6 h-6"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.25v-.75A6.75 6.75 0 0111.25 12.75h1.5a6.75 6.75 0 016.75 6.75v.75" 
            />
          </svg>
          <p className={`${activeFilter.full_name === currentUser.full_name ? "text-green-700 font14px-500" : "font14px-400 text-gray-700"}`}>
            Your Contacts
          </p>
        </div>
      </div>
    </div>
  );
};
